import { getBoApiBasePath } from 'apps/core/utils/services';
import { GET } from 'service/REST';
import type {
  MerchantMetaData,
  GeneralMetaData,
} from 'apps/shared/data-access/types/metadata/metadata.types';

export const fetchGeneralMetadata = async <T = GeneralMetaData>(): Promise<T> => {
  const response = await GET(getBoApiBasePath('/metadata'));
  return response.json() as Promise<T>;
};

export const fetchMerchantMetadata = async <T = MerchantMetaData>(merchantId: number): Promise<T> => {
  const response = await GET(getBoApiBasePath(`/metadata/${merchantId}`));
  return response.json() as Promise<T>;
};
